import { makeStyles, mergeClasses } from '@fluentui/react-components';
import { tokens } from '@fluentui-copilot/tokens';
import type { GroundingMenuListboxSlots, GroundingMenuListboxState } from './GroundingMenuListbox.types';
import type { SlotClassNames } from '@fluentui/react-components';
import { useInputListboxStyles_unstable } from '@fluentui-copilot/react-input-listbox';
import { GROUNDING_MENU_GRID_AREAS } from '../GroundingMenu/useGroundingMenuStyles.styles';

export const groundingMenuListboxClassNames: SlotClassNames<GroundingMenuListboxSlots> = {
  root: 'fai-GroundingMenuListbox',
};

/**
 * Styles for the root slot
 */
const useStyles = makeStyles({
  root: {
    gridArea: GROUNDING_MENU_GRID_AREAS.listbox,
    boxShadow: 'unset',
    borderRadius: 'unset',
    maxHeight: 'unset',
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    backgroundColor: 'unset',
  },
});

/**
 * Apply styling to the GroundingMenuListbox slots based on the state
 */
export const useGroundingMenuListboxStyles_unstable = (state: GroundingMenuListboxState): GroundingMenuListboxState => {
  'use no memo';

  const styles = useStyles();
  state.root.className = mergeClasses(groundingMenuListboxClassNames.root, styles.root, state.root.className);

  useInputListboxStyles_unstable(state);

  return state;
};
